import classnames from "classnames";

import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {getPercentageClass, getResponseTimeClass} from "@/lib/cssUtils.ts";
import {percentage} from "@/lib/format.tsx";
import {SLAReport, SLAReportResponseTime} from "@/lib/queries/reports.ts";
import {formatResponseTime} from "@/pages/checks/analysis/overview/utils.ts";
import {CheckName} from "@/pages/checks/list/components/CheckName.tsx";

interface ServiceResponseTimeTableProps {
  report: SLAReport;
  item: SLAReportResponseTime;
}

export const SLAReportServiceResponseTimeTable = ({report, item}: ServiceResponseTimeTableProps) => (
  <div style={{overflowX: "auto", WebkitOverflowScrolling: "touch"}}>
    <table className="table" style={{minWidth: "800px"}}>
      <thead>
        <tr>
          <th className="w-30">Name</th>
          {report.show_response_time_sla && (
            <th className="w-20 text-center ">
              Target SLA{" "}
              <TooltipIconRA
                iconProps={{
                  display: "inline",
                  removeDivDimensions: true,
                }}
                className="ms-1"
                title="The Target SLA percentage value defined on the Check."
              />
            </th>
          )}
          <th className="text-center">
            Response Time
            <br />
            SLA Achieved
            <TooltipIconRA
              iconProps={{
                display: "inline",
                removeDivDimensions: true,
              }}
              className="ms-1"
              title="The percent of the time over the period that the Check's response time was faster than the Target Response Time SLA value."
            />
          </th>
          {report.show_response_time_sla && (
            <th className="text-center">
              Target Response
              <br />
              Time SLA
              <TooltipIconRA
                iconProps={{
                  display: "inline",
                  removeDivDimensions: true,
                }}
                className="ms-1"
                title="The maximum acceptable response time defined on the Check."
              />
            </th>
          )}
          <th className="text-center ">
            Avg. Response Time
            <TooltipIconRA
              iconProps={{
                display: "inline",
                removeDivDimensions: true,
              }}
              className="ms-1"
              title="The average response time of the Check over the entire period."
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {item.services.map((svc, idx) => (
          <tr key={`sla-service-row-${idx}`}>
            <td>
              <CheckName
                id={svc.service_id}
                name={svc.service_name}
                type={svc.monitoring_service_type}
                address={svc.device_name}
                textClass="text-primary"
              />
            </td>
            {report.show_response_time_sla && <td className="text-center">{percentage(svc.uptime_sla)}</td>}
            <td
              className={classnames(
                "text-center",
                getPercentageClass(svc.totals.response_time_sla_pct, svc.uptime_sla)
              )}
            >
              {svc.totals.response_time_sla_pct ? percentage(svc.totals.response_time_sla_pct) : "N/A"}
            </td>
            <td className="text-center">{formatResponseTime(svc.response_time_sla)}</td>
            {report.show_response_time_sla && (
              <td
                className={classnames(
                  "text-center",
                  getResponseTimeClass(svc.totals.response_time_avg, svc.response_time_sla)
                )}
              >
                {formatResponseTime(svc.totals.response_time_avg)}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
